// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-header[data-v-0cc1ce4c] {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 32px;\n  align-items: flex-start;\n}\n", ""]);
// Exports
module.exports = exports;
